import { Button } from '@/components/ui/Button';
import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminUserDetail } from '@/hooks/useAdminUsers';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserActionsMenu } from '../components/UserActionsMenu';
import { UserInfoCard } from '../components/UserInfoCard';
import { UserActivityLog } from '../components/UserActivityLog';
import { UserSubscriptionCard } from '../components/UserSubscriptionCard';

export function UserDetailPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const { data: response, isLoading } = useAdminUserDetail(uuid);
  const user = (response as any)?.data ?? response;

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-48" />
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          <Skeleton className="h-64" />
          <Skeleton className="h-64 lg:col-span-2" />
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-neutral-600 dark:text-neutral-400">Utilisateur introuvable</p>
        <Button variant="ghost" className="mt-4" onClick={() => navigate('/users')}>
          Retour a la liste
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" icon={<ArrowLeft className="h-4 w-4" />} onClick={() => navigate('/users')} />
          <div>
            <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">{user.firstName} {user.lastName}</h1>
            <p className="text-sm text-neutral-500">{user.email}</p>
          </div>
        </div>
        <UserActionsMenu userUuid={user.uuid} isLocked={!!user.lockedUntil || user.isLocked} />
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <UserInfoCard user={user} />
        <div className="lg:col-span-2 space-y-4">
          <UserSubscriptionCard user={user} />
          <UserActivityLog
            userUuid={user.uuid}
            lastLoginAt={user.lastLoginAt}
            lastLoginIp={user.lastLoginIp}
            failedLoginAttempts={user.failedLoginAttempts}
            lockedUntil={user.lockedUntil}
          />
        </div>
      </div>
    </div>
  );
}
